module.exports = __webpack_public_path__ + "img/depressed.c4d11ff5.svg";